<script>
  export let data;
  import { store, imgSrc } from '$client';
  import { page } from '$app/stores';
  const { other, city } = store;

  $: web = $page.url.origin;
  $: pageN = $page.url.searchParams.get('page');
  $: add = ` г. ${$city.header} ${pageN ? '. Страница №' + pageN : ''}`;
  $: title = data.title + add;
  $: desc = data.description + add;
</script>

<svelte:head>
  {#if !data.allowRobots}
    <meta name="robots" content="noindex" />
  {/if}

  <title>{title}</title>
  {#if !data?.metaTags?.includes('rel="canonical"')}
    <link rel="canonical" href={`${web + ($page.url.pathname !== '/' ? $page.url.pathname : '')}`} />
  {/if}
  {#if data.keywords?.length > 0}
    <meta name="keywords" content={`${data.keywords}, ${add.replace('г.', '').replace('.', ',')}`} />
  {/if}
  <meta name="description" content={desc} />
  <meta property="og:description" content={desc} />
  <meta property="og:url" content={$page.url.href} />
  <meta property="og:title" content={title} />
  <meta property="og:image" content={web + '/favicon.svg'} />
  <meta name="apple-mobile-web-app-title" content={title} />
  <link rel="preconnect" href={imgSrc('')} crossorigin />

  {#if data.metaTags}
    {@html data.metaTags}
  {/if}

  {#if $other.metaTags}
    {@html $other.metaTags}
  {/if}
</svelte:head>
